import { RaiseFundApplicationProcessModule } from '../../enum/raise-fund-application-process-module.enum';

export class TabContent {
  tab: RaiseFundApplicationProcessModule;
  name: string;
  title: string;
  btnText: string;
  hoverText?: string;
  isEnabled?: () => boolean;
}
